import { IoMdClose } from "react-icons/io";
import { Slider } from "@material-ui/core";
import AsyncSelect from "react-select/async";
import { useSelector } from "react-redux";
import { isAgentUser } from "utils/helper";
import { GrCircleInformation } from "react-icons/gr";
import { Modal, Typography, Button } from "components";

const ActiveInactiveTerminalsModal = ({
  showModal,
  activeInactiveTerminalQuery,
  handleModalClose,
  loadAgentsSuggestion,
  agentSearchStyles,
  terminalActivitySelectedAgent,
  setTerminalActivitySelectedAgent,
  handleActiveInActiveTerminalQueryChange,
}) => {
  const { user } = useSelector((state) => state.user);

  return (
    <Modal showModal={showModal} onClose={handleModalClose} customPadding={"0"}>
      <div className="report-filter-modal">
        <div className="header">
          <div className="d-flex justify-content-end ">
            <IoMdClose
              className="cursor-pointer"
              onClick={() => handleModalClose()}
            />
          </div>
          <Typography className={"text-center"}>
            Set Threshold for Terminal Report
          </Typography>
        </div>
        {!isAgentUser(user) && (
          <div
            style={{
              margin: "3rem auto",
              width: "fit-content",
            }}
          >
            <Typography
              className={"text-center"}
              state="primary"
              variant="caption2"
            >
              Choose Agent
            </Typography>
            <AsyncSelect
              cacheOptions
              loadOptions={loadAgentsSuggestion}
              styles={agentSearchStyles}
              value={terminalActivitySelectedAgent}
              placeholder="Search with Agent Code, ID or Name"
              onChange={(value) => {
                setTerminalActivitySelectedAgent(value || {});
                handleActiveInActiveTerminalQueryChange({
                  name: "agentId",
                  value: value?.value,
                });
              }}
              isClearable
              loadingMessage={() => "Searching Agents..."}
            />
          </div>
        )}

        <div className="px-4 my-4">
          <Typography
            state="primary"
            variant="caption2"
            className={"text-center mb-3"}
          >
            Set the last number of days for terminal activity
          </Typography>
          <Slider
            valueLabelDisplay="auto"
            value={activeInactiveTerminalQuery.threshold}
            onChange={(e, value) => {
              handleActiveInActiveTerminalQueryChange({
                name: "threshold",
                value,
              });
            }}
            size="large"
            style={{ width: "100%" }}
            color="primary"
            min={0}
            max={180}
          />
          <div className="filter-note">
            <span>Note that</span>{" "}
            <span>
              <GrCircleInformation />
            </span>{" "}
            <span>Maximum of 180 days (last 6 months) can be selected</span>
          </div>
          <div className="filter-note-detail">
            <span>
              According to your set threshold, terminals that didn't perform any
              transaction for the selected transaction type within the last
            </span>{" "}
            <span className="bold">
              {activeInactiveTerminalQuery.threshold}
            </span>{" "}
            days will be considered as <span>Inactive terminals</span>, while
            terminals that perform 1 or more transactions for the selected
            transaction type in the last{" "}
            <span className="bold">
              {activeInactiveTerminalQuery.threshold}
            </span>{" "}
            days that period will be considered{" "}
            <span className="bold">Active terminals</span>.
          </div>
          <Button
            label="Apply"
            size="xs"
            className={"mx-auto"}
            onClick={() => handleModalClose()}
          />
        </div>
      </div>
    </Modal>
  );
};

export default ActiveInactiveTerminalsModal;
